import { useEffect, useRef } from 'react';
import axios from 'axios';

export const useCancellableRequest = () => {
  const abortControllerRef = useRef(null);

  const makeRequest = async (config) => {
    // cancel any existing request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // create new abort controller
    abortControllerRef.current = new AbortController();

    try {
      const response = await axios({
        ...config,
        signal: abortControllerRef.current.signal,
        timeout: 15000 
      });
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Request was cancelled');
        return null;
      }
      throw error;
    }
  };

  const cancelRequest = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  useEffect(() => {
    return () => {
      // cleanup on unmount
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return { makeRequest, cancelRequest };
};